export default __webpack_public_path__ + "static/media/i084jp.5f9513cb.webp";